var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoaded)?_c('div',{staticClass:"loader-wrapper"},[_c('fingerprint-spinner',{attrs:{"animation-duration":1500,"size":64,"color":"#FF96AD"}})],1):_vm._e(),_c('Content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }